import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { CBadge, CButton, CCard, CCardBody } from '@coreui/react-pro';
import images from '../../../../../../assets/images';

import { POPUP_CHOOSE_TRAINING_EVENT_DATE } from '../../../../../../constants';

import { setShow, setShowEditPopup, setShowPopupDetail } from '../../../../../../actions/general';

const ButtonElement = ({ handleClickSee }) => {
     const [isShown, setIsShown] = useState(false);

     return (
          <div className="view-details-events" onMouseEnter={() => setIsShown(true)} onMouseLeave={() => setIsShown(false)}>
               <CButton color="link" className="btn-details" onClick={handleClickSee}>
                    See available dates
               </CButton>

               <CButton color="link" onMouseEnter={() => setIsShown(true)} onClick={handleClickSee}>
                    {<img src={isShown ? images.arrowBlueHighlight : images.Group2} alt="" />}
               </CButton>
          </div>
     );
};

const LinkElement = ({ linkToDetail }) => {
     const [isShown, setIsShown] = useState(false);

     return (
          <div className="view-details-events" onMouseEnter={() => setIsShown(true)} onMouseLeave={() => setIsShown(false)}>
               <Link className="btn btn-outline-none-primary btn-details" to={linkToDetail}>
                    view details
               </Link>

               <Link to={linkToDetail} onMouseEnter={() => setIsShown(true)}>
                    {<img src={isShown ? images.arrowBlueHighlight : images.Group2} alt="" />}
               </Link>
          </div>
     );
};

const YourEventCreditCard = ({ course, linkToDetail }) => {
     const dispatch = useDispatch();

     const isOrganization = course?.organizationId;

     const cardTitle = isOrganization ? 'Seats with no date.' : 'Select a date for this training event.';

     const handleClickSee = () => {
          if (!course?.productId || isOrganization) {
               return;
          }

          dispatch(setShowPopupDetail(course.productId));
          dispatch(setShowEditPopup(course.id));
          dispatch(setShow(POPUP_CHOOSE_TRAINING_EVENT_DATE));
     };

     const ButtonLinkElement = () => {
          if (isOrganization) {
               return <LinkElement linkToDetail={linkToDetail} />;
          }

          return <ButtonElement handleClickSee={handleClickSee} />;
     };

     return (
          <CCard className="timeline-training event-credit">
               <CCardBody>
                    <p className="card-title">{cardTitle}</p>

                    <div className="events-status">
                         {!isOrganization && <CBadge className="badge-pill badge-outline-primary">NO DATE SELECTED</CBadge>}
                         <ButtonLinkElement />
                    </div>
               </CCardBody>
          </CCard>
     );
};

export default YourEventCreditCard;
